import { GET_PGROUTER, UPDATE_ISPAYIN_DOWN,  } from "../api/constApi";
import { apiInstance } from "./axiosApi";

export const getRouter = (payload) => {
  return apiInstance.post(GET_PGROUTER, payload);
};
export const updateIsPayinDown = (payload) => {
  return apiInstance.post(UPDATE_ISPAYIN_DOWN, payload);
};
